export default __webpack_public_path__ + "static/media/icon-website-evaluation.dfd45070.svg";